import { Pipe, PipeTransform } from '@angular/core';

import { getCellContentValue } from 'src/app/table-handling/util';

@Pipe({
  name: 'cellValue',
  standalone: true,
})
export class CellValuePipe implements PipeTransform {
  public transform = getCellContentValue;
}
